module.exports = __webpack_public_path__ + "static/mbb-logo-1-96x96-b18f116abaf71b76009bb940c9261516.png";